import React from 'react';

import { Container } from './styles';

const News: React.FC = () => {
  return (
    <Container>
      <span>Assuntos do momento no Brasil</span>
      <strong>Presidente declara que está proibido ser feliz </strong> 
    </Container>
  );
}

export default News;